import { TrialHomePage } from './trial-home-page';

export const HomePageLayout = () => {
  return <TrialHomePage />;
};
